import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../environments/environment';
import {getAccount, getUserId} from './consts/utilities';

@Injectable({
  providedIn: 'root'
})
export class AccountVerificationService {
    private readonly BASE_URL: string;

    constructor(
        private http: HttpClient,
    ) {
        this.BASE_URL = `${environment.serverURL}/verification`;
    }

    requestCodeWithNoDisturb(): Observable<any> {
        const id = getUserId();
        const account = getAccount();
        const body = { id, account  };
        return this.http.post(`${this.BASE_URL}/request-code-silently`, body);
    }

    sendLinkCode(
        userId: string,
        account: string,
    ): Observable<any> {
        const body = { userId, account };

        return this.http.post(
            `${this.BASE_URL}/request-code`, body
        );
    }

    sendRecoveryCode(account: string, channel: string, userId?: number): Observable<any> {
        const body = {
            account,
            channel,
            userId,
        };
        const params = JSON.stringify(body);

        return this.http.get(
        `${this.BASE_URL}/recovery-code/${params}`);
    }

    validateVerificationCode(account: string, code: string, accountType: string): Observable<any> {
        const id = getUserId();
        const payload = {
            userId: id,
            account,
            code,
            channel: accountType
        };

      return this.http.post(
        `${this.BASE_URL}/code-confirmation`, payload
      );
    }
}
